<div class="router-bar">
    <div class="route-button" [ngClass]="{'current-route': router.url === '/planning'}">
        <button mat-button [routerLink]="['/planning']">Activities</button>
    </div>
    <div class="route-button" [ngClass]="{'current-route': router.url === '/production'}">
        <button mat-button [routerLink]="['/production']">Production Posts</button>
    </div>
</div>


<div class="production-planning-content" >
  <app-activity-calendar></app-activity-calendar>
</div>

